<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}样商品(点击商品查看明细)</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper" style="margin-top:15px"
        v-for="(cart,index) in cartInfo"
        :key="cart.id"  
      >
	 
	  
        <div class=" "  >
       {{ index+1 }}
        </div>
        <div class="text" @click="$router.push({ path: '/order/ordercaigougoodsdetail/' + cart.id+'/' + cart.cgd_id+'/'+ cart.cp_id})" >
          <div class="acea-row row-between-wrapper">
            <div class="name line2">{{ cart.goods_name }}<span style="float:right">x {{ cart.sl }}{{ cart.danwei_name }}</span></div>
		 
         
          </div>
          <div class="num" v-if="cart.title">规格：{{ cart.title }}	 </div>
 <div class="name line2"  >
            供应商：{{ cart.gysname }}
          </div>
        </div>
	 
	 
		  <div v-if="edit==true" class="bnt bg-color-red" style="padding: 5px 5px;color:white; "   @click="showInputModal(cart.id,cart.gys_id,cart.sl,cart.cgd_id)">修改</div> 
	
	 <div v-if="edit==true" class="bnt bg-color-red" style="padding: 5px 5px;color:white;display:none" @click="shanchu(cart.id)">删除</div> 
	  <div class="line"   style="margin-top:5px">
        <img src="@assets/images/line.jpg" />
      </div>
      </div>
	  	<!-- 弹窗组件 -->
    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        
		
		 修改供应商:
	  <div class="custom-select-container">

 
    <select class="custom-select" v-model="selected">

<option v-for="option in options" v-bind:value="option.value">
    {{ option.text }}
  </option>
     


    </select>
	 
	  </div>
	 
        <div class="actions">
          <button @click="closeModal">取消</button>
          <button @click="confirmInput"  >确定</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { editcaigougoods,getgyslist } from "@api/order";
import Modal from '../components/input/input'
import {
  shanchuzhipeigoodsHandle
} from "@libs/order";
// 引用全局VUE中的接口
import Vue from 'vue';
export default {
 components: { Modal },
  name: "OrderGoods",
  props: {
     
    cartInfo: {
      type: Array,
      default: () => []
    },
	edit:{
	default:false
	}
	 

  },
  data: function() {
    return {
	  showModal: false,      // 控制弹窗显示
      tempValue: 0 ,          // 临时存储输入值
	id: '' ,
	options: [],
	 cg_id: '' ,
	selected:''
	
	};
  },
  mounted: function() {
   this.getgys();
  
  },
  methods: {
 getgys() {
	    getgyslist()
        .then(res => {
		   this.options = res.data;
		
		  })
        .catch(err => {
         // this.$dialog.error(err.msg);
        // this.$router.go(-1);
        });
    },
  shanchu(id){
  console.log(id);
    shanchuzhipeigoodsHandle(id)
        .then(() => {
          //location.reload()
		    this.$emit('custom-event');
        })
        .catch(() => {
           
        });
  
  
  
  },
  // 显示明细
    showmingxi(cgd_id,id,cp_id,cp_name,title,gys_name) {
	 console.log(cgd_id+'/'+id+'/'+cp_id+'/'+cp_name+'/'+title+'/'+gys_name);
	
	},
  // 显示输入弹窗
    showInputModal(id,gys_id,sl,cgd_id) {
		 console.log(id+'/'+cgd_id);
	if(this.edit==true){
	
 
	
 
      this.showModal = true;
      this.tempValue = sl; // 初始化输入值为当前数量
      this.id = id; 
	     this.selected = gys_id; 
		  this.cgd_id = cgd_id; 
      // 自动聚焦输入框
      this.$nextTick(() => {
 
 
       // this.$refs.modalInput.focus();
		  
       // this.$refs.modalInput.select(); // 自动选中文本方便修改
		 
      });
	  	}
    },
    
    // 关闭弹窗
    closeModal() {
      this.showModal = false;
    },
    
    // 确认输入
    confirmInput() {
      
     const gysid = Number(this.seleted);
	  
	  
	  if(gysid==''){
	  alert('请选择供应商');
        return;
	  }
      
      // 更新商品数量
    
	   
			console.log(this.id+'/'+this.selected);
			
			
			  editcaigougoods(this.id,this.selected,this.cgd_id)
        .then((res) => {
           console.log(res);
		    this.$emit('custom-event');
		   
			   
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
			
    
     
      
      this.closeModal();
    },
  
  
  }
};
</script>

<style lang="less"  scoped>
@import "../common/less/index.less";
.cartcontrol{
	font-size: 0;
	.cart-decrease{
		display:inline-block;
		padding:6px;
		transition:all 0.4s linear;
		transform:translate3D(0,0,0);
	    .inner{
	    	display:inline-block;
	    	line-height:24px;
			font-size: 24px;
			color:rgba(0,160,220);
			transform:rotate(0);
			transition:all 0.4s linear;
	    }
		&.move-enter,&.move-leave-to{
			opacity:0;
			transform:translate3D(24px,0,0);
			.inner{
				transform:rotate(180deg);
			}
		}	    
	}
	.cart-count{
		display:inline-block;
		font-size: 10px;
		vertical-align:top;
		width:22px;
		padding-top: 6px;
		color:#93999f;
		line-height:24px;
		text-align: center;
	}
	.cart-add{
		display:inline-block;
		padding:6px;
		line-height:24px;
		font-size: 24px;
		color:rgba(0,160,220)
	}
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保在顶层 */
}

.modal-content {
  background: white;
  padding: 25px; /* 增加内边距 */
  border-radius: 10px; /* 圆角增大 */
  width: 320px; /* 加宽 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* 添加阴影 */
  
  input {
     width: 150px;
    padding: 12px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    margin-left:20px;
    &:focus {
      border-color: rgba(0, 160, 220);
      outline: none;
    }
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px; /* 增大间距 */
  margin-top: 20px; /* 增加上边距 */
  
  button {
    padding: 10px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
	line-height:20px;
    &:first-child {
      background: #f0f0f0;
      
      &:hover {
        background: #e0e0e0;
      }
    }
    
    &:last-child {
      background: rgba(0, 160, 220);
      color: white;
      
      &:hover {
        background: rgba(0, 140, 200);
      }
    }
  }
}
.custom-select-container {
  position: relative;
  display: inline-block;
  width: 150px;
  margin-top:15px
}
.custom-select {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f9f9f9;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.custom-select-container::after {
  content: '▼';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}
</style>